import type { NumberFormatOptions } from 'next-intl';

const COMPACT_USD: NumberFormatOptions = {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
};

const WHOLE_USD: NumberFormatOptions = {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
};

/** A market's volume as Figma prints it: "$3.2M", "$640K" — and "$710", not "$709.6". */
export function volumeFormatOptions(value: number): NumberFormatOptions {
  return Math.abs(value) < 1000 ? WHOLE_USD : COMPACT_USD;
}
